var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"scrollOnTop"}},[_c('router-link',{nativeOn:{"click":function($event){return _vm.$scrollToTop.apply(null, arguments)}}},[_c('a',{attrs:{"href":""}},[_vm._v("On top")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }